export default __webpack_public_path__ + "ad824022968875e4a39e4a05d750b6b4.jpg";